import { Directory } from ".";
import axios from "../providers/axios.provider";
import { AxiosResponse } from "axios";

type AzureAdDirectoryResponse = {
    value?: Directory[];
};

export const getDirectoriesRequest = async (): Promise<AxiosResponse<AzureAdDirectoryResponse>> => {
    return await axios.get<AzureAdDirectoryResponse>("https://management.azure.com/tenants?api-version=2022-12-01");
};

export type AzureAdOrganization = {
    id: string;
    displayName: string;
};

type AzureAdOrganizationResponse = {
    value?: AzureAdOrganization[];
};

type GraphBatchPhotoResponse = {
    responses: Array<{
        id: string;
        status: number;
        headers?: Record<string, string>;
        body?: string;
    }>;
};

export const requestAzureADOrganization = async (): Promise<AxiosResponse<AzureAdOrganizationResponse>> => {
    return await axios.get<AzureAdOrganizationResponse>("https://graph.microsoft.com/v1.0/organization");
};

const base64UrlToBlob = (value: string, contentType: string): Blob => {
    const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
    const paddedBase64 = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    const binary = window.atob(paddedBase64);
    const bytes = Uint8Array.from(binary, character => character.charCodeAt(0));

    return new Blob([bytes], { type: contentType });
};

export const getPhotoRequest = async (): Promise<Blob | undefined> => {
    const response = await axios.post<GraphBatchPhotoResponse>(
        "https://graph.microsoft.com/v1.0/$batch",
        {
            requests: [
                {
                    id: "profile-photo",
                    method: "GET",
                    url: "/me/photo/$value",
                },
            ],
        }
    );

    const photoResponse = response.data.responses.find(item => item.id === "profile-photo");

    if (!photoResponse || photoResponse.status === 404) {
        return undefined;
    }

    if (photoResponse.status !== 200 || typeof photoResponse.body !== "string") {
        throw new Error(`Microsoft Graph profile photo request failed with status ${photoResponse.status}.`);
    }

    const contentTypeHeader = Object.entries(photoResponse.headers ?? {}).find(
        ([name]) => name.toLowerCase() === "content-type"
    )?.[1];
    const contentType = contentTypeHeader?.split(";")[0] || "image/jpeg";

    return base64UrlToBlob(photoResponse.body, contentType);
};
